import { Component, Input } from '@angular/core';

@Component({
    selector: 'app-cov-feedback',
    templateUrl: './cov-feedback.component.html',
    styleUrls: ['./cov-feedback.component.scss'],
})
export class CovFeedbackComponent {
    @Input() questionAnswer: any = [];
    @Input() interviewDetails: any = [];
    @Input() blob: any = '';

    today: any = new Date()
}
